// Row of headline figures in a card: [{ label, value }] → label over a
// ds-stat-value, separated by hairlines. Extra content (e.g. a coverage bar)
// is passed as children and fills the remaining width.
import { Fragment } from "react";
import "./Matching.css";

export default function StatTiles({ stats, children }) {
  return (
    <div className="ds-card mt-summary">
      {stats.map((s, i) => (
        <Fragment key={s.label}>
          {i > 0 && <div className="mt-stat-divider" aria-hidden="true" />}
          <div className="mt-stat">
            <span className="ds-stat-value">{s.value ?? "—"}</span>
            <span className="ds-meta">{s.label}</span>
          </div>
        </Fragment>
      ))}
      {children}
    </div>
  );
}
